// Helper functions for working with fight results
import { fightResultsMap } from "../constants/FightResultsMap";

/**
 * Generate a result key from fight type, outcome, and round
 */
export const generateResultKey = (type, outcome, round) => {
  if (type === "special") return null;

  const roundNames = {
    1: "firstround",
    2: "secondround",
    3: "thirdround",
    4: "fourthround",
    5: "fifthround",
  };

  const key = `${type}${roundNames[round]}${outcome}`;
  return fightResultsMap[key] ? key : null;
};

/**
 * Get available rounds for a fight type
 */
export const getAvailableRounds = (fightType) => {
  if (fightType === "mainevent") {
    return [
      { value: "1", label: "Round 1" },
      { value: "2", label: "Round 2" },
      { value: "3", label: "Round 3" },
      { value: "4", label: "Round 4" },
      { value: "5", label: "Round 5" },
    ];
  } else if (fightType === "standard") {
    return [
      { value: "1", label: "Round 1" },
      { value: "2", label: "Round 2" },
      { value: "3", label: "Round 3" },
    ];
  }
  return [];
};

/**
 * Get special result options
 */
export const getSpecialResults = () => {
  return Object.entries(fightResultsMap)
    .filter(([_, result]) => result.type === "special")
    .map(([key, result]) => ({
      key,
      label: result.label,
      score: result.score,
    }));
};

/**
 * Parse a result key to get its components
 */
export const parseResultKey = (key) => {
  if (!key || !fightResultsMap[key]) return null;

  const result = fightResultsMap[key];
  return {
    type: result.type,
    outcome: result.outcome,
    round: result.round?.toString(),
    label: result.label,
    score: result.score,
  };
};
